module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-93.c79dc695.svg";